// Which sidebar destination was clicked. Values stay stable when the visible label changes.
export enum SidebarLink {
  Matters = 'matters',
  BackToAllMatters = 'back_to_all_matters',
  MatterOverview = 'matter_overview',
  MatterFiles = 'matter_files',
  Drafts = 'drafts',
  Tables = 'tables',
  Timeline = 'timeline',
  MedicalChronology = 'medical_chronology',
  MedicalBills = 'medical_bills',
}
